import PropTypes from "prop-types"
import React, { useCallback, useEffect, useRef, useState } from "react"

// //Import Scrollbar
import SimpleBar from "simplebar-react"

// Router
import withRouter from "components/Common/withRouter"
import { Link } from "react-router-dom"

// Lucide icons for modern look
import {
  LayoutDashboard, Users, ScanLine, Settings as SettingsIcon,
  Shield, BarChart3, Zap, Search as SearchIcon, Mail,
  Layout, Wrench, AlertTriangle, Smartphone, Cpu,
  FileText, Globe, Book, Map
} from 'lucide-react'

//i18n
import { withTranslation } from "react-i18next"
import { useSelector } from "react-redux"
import { DEFAULTADMINPAGE, DEFAULTUSERPAGE, NOTSCANPAGE, PAGECODE, SIDEBARDATA, USERTYPES } from "components/Common/Constant"
import { keyBy } from "lodash"

// Modern icon mapping
const MODERN_ICONS = {
  11: <Users size={20} />,
  12: <Users size={20} />,
  14: <Users size={20} />,
  17: <ScanLine size={20} />,
  18: <SettingsIcon size={20} />,
  19: <FileText size={20} />,
  21: <FileText size={20} />,
  20: <LayoutDashboard size={20} />,
  16: <ScanLine size={20} />,
  24: <LayoutDashboard size={20} />,
  13: <Book size={20} />,
  1: <Users size={20} />,
  5: <Shield size={20} />,
  7: <BarChart3 size={20} />,
  8: <Zap size={20} />,
  4: <SearchIcon size={20} />,
  15: <Mail size={20} />,
  2: <Layout size={20} />,
  9: <Wrench size={20} />,
  3: <AlertTriangle size={20} />,
  6: <Smartphone size={20} />,
  10: <Cpu size={20} />,
  23: <Map size={20} />,
  25: <FileText size={20} />,
   30: <FileText size={20} />,
}

const SidebarContent = props => {
  const ref = useRef();

  const activeMenu = useCallback(() => {
    const pathName = process.env.PUBLIC_URL + props.router.location.pathname;
    const sidebarMenu = document.getElementById("sidebar-menu");

    if (!sidebarMenu) return;

    const items = sidebarMenu.getElementsByClassName("modern-nav-link");

    // Remove active class from all items
    Array.from(items).forEach(item => {
      item.classList.remove("active");
      const parent = item.closest(".modern-menu-item");
      if (parent) {
        parent.classList.remove("mm-active");
      }
    });

    // Add active class to matching item
    for (let i = 0; i < items.length; ++i) {
      if (pathName === items[i].pathname || pathName === items[i].getAttribute('href')) {
        items[i].classList.add("active");
        const parent = items[i].closest(".modern-menu-item");
        if (parent) {
          parent.classList.add("mm-active");
        }
        break;
      }
    }
  }, [props.router.location.pathname]);

  const [adminSession, setAdminSession] = useState([])
  const [userSession, setUserSession] = useState([])

  useEffect(() => {
    if (ref.current) {
      ref.current.recalculate();
    }
  }, []);

  // Skip MetisMenu initialization for modern sidebar
  // Modern sidebar doesn't use MetisMenu

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    activeMenu();
  }, [activeMenu]);

  useEffect(() => {
    if (sessionStorage.getItem('pages')) { // TODO: is this needed? pages is never set since scan details are hidden in scan list page.
      const adSess = sessionStorage.getItem('pages').split(';')
        .map(Number)
        .filter(p => !NOTSCANPAGE.includes(p))

      // const defaultPg = user.userType === USERTYPES.Standard
      //   ? DEFAULTUSERPAGE
      //   : DEFAULTADMINPAGE

      // const usSess = sessionStorage.getItem('pages').split(';')
      //   .map(Number)
      //   .filter(p => !defaultPg.includes(p))

      setAdminSession(adSess)
      setUserSession(adSess)
    }
    else {
      const adSess = user.permissions.read.filter(p => !NOTSCANPAGE.includes(p)) || [];
      // console.log(user);
      // setAdminSession(adSess);
      setUserSession(adSess);
    }
  }, [sessionStorage.getItem('pages')]);

  const user = useSelector((state) => state?.users.users)

  const getRouteDetails = (page) => {
    //console.log(page, 'pagepagepagepagepage.Admin');
    return SIDEBARDATA.find(obj => obj.pageCode === page)
  }
  console.log(USERTYPES.Admin, 'USERTYPES.Admin');

  // Render individual menu item
  const renderMenuItem = (page, key) => {
    const route = getRouteDetails(Number(page))
    if (!route) return null

    const isExternal = Number(page) === 20
    const icon = MODERN_ICONS[Number(page)] || route.icon

    return (
      <li key={key} className="modern-menu-item">
        {isExternal ? (
          <a
            href={route.route}
            target="_blank"
            rel="noopener noreferrer"
            className="modern-nav-link"
          >
            <span className="modern-nav-icon">{icon}</span>
            <span className="modern-nav-text">{props.t(route.name)}</span>
          </a>
        ) : (
          <Link to={route.route} className="modern-nav-link">
            <span className="modern-nav-icon">{icon}</span>
            <span className="modern-nav-text">{props.t(route.name)}</span>
          </Link>
        )}
      </li>
    )
  }

  return (
    <React.Fragment>
      <div className="modern-sidebar-content">
        <SimpleBar style={{ height: "100%" }} ref={ref}>
          <div id="sidebar-menu">
            {Object.keys(user).length !== 0 && user.userType !== USERTYPES.Admin ? (
              <>
                {/* MENU Section */}
                <div className="modern-menu-label">MENU</div>
                <ul className="modern-menu-list">
                  {[...NOTSCANPAGE.filter(pg => user.permissions?.read?.includes(pg) || true), {/*...userSession*/}]
                    .filter(page => Object.values(PAGECODE).includes(page))
                    .map((page, key) => renderMenuItem(page, `menu-${key}`))}
                </ul>

                {/* GENERAL Section */}
                <div className="modern-menu-label">GENERAL</div>
                <ul className="modern-menu-list">
                  {userSession
                    .filter(page => Object.values(PAGECODE).includes(page))
                    .map((page, key) => renderMenuItem(page, `general-${key}`))}
                </ul>
              </>
            ) : Object.keys(user).length !== 0 && user.userType === USERTYPES.Admin ? (
              <>
                {/* MENU Section */}
                <div className="modern-menu-label">MENU</div>
                <ul className="modern-menu-list">
                  {[...DEFAULTADMINPAGE]
                    .filter(page => Object.values(PAGECODE).includes(Number(page)))
                    .map((page, key) => renderMenuItem(page, `menu-${key}`))}
                </ul>

                {/* GENERAL Section */}
                {adminSession.length > 0 && (
                  <>
                    <div className="modern-menu-label">GENERAL</div>
                    <ul className="modern-menu-list">
                      {adminSession
                        .filter(page => Object.values(PAGECODE).includes(Number(page)))
                        .map((page, key) => renderMenuItem(page, `general-${key}`))}
                    </ul>
                  </>
                )}
              </>
            ) : (
              <>
                <div className="modern-menu-label">MENU</div>
                <ul className="modern-menu-list">
                  <li className="modern-menu-item">
                    <Link to="/addsiteurl" className="modern-nav-link">
                      <span className="modern-nav-icon"><Users size={20} /></span>
                      <span className="modern-nav-text">{props.t("User Management")}</span>
                    </Link>
                  </li>
                </ul>
              </>
            )}
          </div>
        </SimpleBar>
      </div>
    </React.Fragment>
  )
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
}

export default withRouter(withTranslation()(SidebarContent))
